import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { AppConfig } from 'data/terra/AppConfig';
import { AppVersion } from 'data/terra/AppVersion';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { AppSelectorState } from '../reducer';

export const SELECT_APP_VERSION = 'SELECT_APP_VERSION';

export interface SelectAppVersionAction {
  type: typeof SELECT_APP_VERSION;
  appVersion: AppVersion;
  appConfigs: AppConfig[];
}

export const selectAppVersion = (
  appVersion: AppVersion
): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch,
  getState
) => {
  const { selectedApp } = getState().appSelector;

  if (selectedApp) {
    const result = await Terra.appConfig.fetchAppConfigs(
      selectedApp.id,
      appVersion.id
    );
    if (result.isSuccess()) {
      dispatch({
        type: SELECT_APP_VERSION,
        appVersion,
        appConfigs: result.get()!.data,
      } as SelectAppVersionAction);
    }
  }
};

export const selectAppVersionDelegate: DelegateMapEntry<
  SelectAppVersionAction,
  AppSelectorState
> = {
  [SELECT_APP_VERSION]: (
    state: AppSelectorState,
    action: SelectAppVersionAction
  ): AppSelectorState => {
    return {
      ...state,
      selectedAppVersion: action.appVersion,
      appConfigs: action.appConfigs,
      selectedEnv: undefined,
    };
  },
};
